import * as React from 'react';
import classnames from 'classnames';
import { MessagePropertiesContext } from '../../../../contexts/messageProperties';
import { ListerContext } from '../../listerContext';
import { ListerActionTypes } from '../../listerReducer';

import styles from './errorBoundary.module.pcss';

interface ErrorProps {
  children?: React.ReactNode;
}

interface ErrorState {
  hasError: boolean;
}

function ErrorMessage(props): React.ReactElement {
  const { onRevert } = props;
  const [formattedMessage] = React.useContext(MessagePropertiesContext);
  const message = formattedMessage({
    id: 'search.page.error',
    fallback: 'Sorry, there was an error, please try again'
  });

  return (
    <div className={styles['error-boundary']}>
      <div className={styles['error-boundary__text']}>{message}</div>
      <button
        className={classnames('button--secondary-dark', 'button--large')}
        onClick={(): void => onRevert()}
        type="button"
      >
        Show previous result
      </button>
    </div>
  );
}

class ErrorBoundary extends React.Component<ErrorProps, ErrorState> {
  constructor(props: ErrorProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    console.error(error, info);
  }

  render(): React.ReactNode {
    const { hasError } = this.state;
    const { children } = this.props;

    const onRevert = (): void => {
      const [, dispatch] = this.context;

      dispatch({ type: ListerActionTypes.REVERT_LISTER_RESULTS });

      this.setState({
        hasError: false
      });
    };

    return hasError ? <ErrorMessage onRevert={onRevert} /> : children;
  }
}

ErrorBoundary.contextType = ListerContext;

export default ErrorBoundary;
